///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../../abstract-command';
import { ActivityDTO } from '../../../../../../services/project-socket/activity-dto.model';
import { GtthProgressWindowModel } from '../../../../../project-windows/progress-window/progress-window.model';
import { GtthLockProjectCommand } from '../../project/lock-project-command';

export class GtthAutoSelectProductsCommand extends GtthAbstractCommand {
    private layerIndex: number;

    getCommandName(): string {
        return 'GtthAutoSelectProductsCommand';
    }

    create(layerIndex: number): this {
        this.layerIndex = layerIndex;
        return this;
    }

    protected doCommand(): void {
        this.historyService.progressWindowService.show(GtthProgressWindowModel.create(this.getCommandName()));
        const activity = this.createActivityDTO(false);
        activity.logicalTopology = this.historyService.logicalTopology.toGeoJsonMainConfig(this.historyService, this.project.name);
        activity.designConfig = this.historyService.logicalTopology.getDesignConfig();
        activity.designConfig.layerIndex = this.layerIndex;
        this.sendActivity(activity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        this.historyService.progressWindowService.show(GtthProgressWindowModel.createFromActivityDTO(activityDto));

        if (!activityDto.progress?.finished) {
            return;
        }

        const lockTimeout = this.commandResolve ? 0 : 1000;

        setTimeout(() => {
            const lockCommand = this.historyService.command(GtthLockProjectCommand).create(false);
            this.historyService.doCommandBypassHistory(lockCommand).then(() => {
                this.historyService.clearHistory();
                if (this.commandResolve) {
                    this.commandResolve(activityDto.successful);
                }
            });
        }, lockTimeout);
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
